import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_NAVIGATION_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_NAVIGATION_SCHEMA);
const KEYS: any = generateKeys(TRACKING_NAVIGATION_SCHEMA);

export class NavigationTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.navigation;
  }

  get properties() {
    return this.toJS();
  }
}
